module.exports = __webpack_public_path__ + "img/29.21087b45.png";